// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"styles_inputWrapper__Ygt2r","input":"styles_input__n2YGU","label":"styles_label__vtNJx"};